import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
// 全站安全网层:窄屏响应式兜底 + 无障碍补强(焦点态/减动画/对比度)。置于 index.css 之后以覆盖。
import '@/styles/responsive.css'
import '@/styles/a11y.css'
import '@/styles/research-workspace.css'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
